import {
  action,
  Action,
  createContextStore,
  ThunkOn,
  thunkOn,
} from 'easy-peasy';
import { ApolloClient } from '@apollo/client';
import { getSalesByUnivers } from './__generated__/getSalesByUnivers';

type LandingModel = {
  apolloClient: ApolloClient<object> | undefined;
  saleType: string;
  sales: getSalesByUnivers;

  setSales: Action<LandingModel, getSalesByUnivers | null>;
  setSaleType: Action<LandingModel, string>;
  onChangeUnivers: ThunkOn<LandingModel>;
};

const landingModel = (
  apolloClient: ApolloClient<object> | undefined
): LandingModel => ({
  /* Values */
  saleType: '',
  apolloClient,
  sales: null,
  /* Actions */
  setSales: action((state, payload) => {
    state.sales = payload;
  }),
  setSaleType: action((state, payload) => {
    state.saleType = payload;
  }),
  onChangeUnivers: thunkOn(
    (actions) => actions.setSaleType,
    // handler:
    async (actions, { payload: saleType }, { getState }) => {
      const apolloClient = getState().apolloClient;
      if (!apolloClient) return;
    }
  ),
});

export default createContextStore(landingModel, { name: 'LandingStore' });
